import React from 'react';
import { DollarSign } from 'lucide-react';

// Simulated market data - in a real app, this would come from a real-time API
const marketPrices = [
  {
    crop: "Coffee (Arabica)",
    price: "215.35",
    unit: "USD/lb",
    change: "+2.3%",
    isUp: true
  },
  {
    crop: "Cocoa",
    price: "4,821.00",
    unit: "USD/MT",
    change: "+5.1%",
    isUp: true
  },
  {
    crop: "Banana",
    price: "1.25",
    unit: "USD/kg",
    change: "-0.8%",
    isUp: false
  }
];

const MarketPrices: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h3 className="text-sm font-semibold mb-3 flex items-center gap-2">
        <DollarSign className="text-green-600 h-4 w-4" />
        Global Market Prices
      </h3>
      <div className="space-y-2">
        {marketPrices.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm">
            <span className="text-gray-600 font-medium">{item.crop}</span>
            <div className="flex items-center gap-2">
              <span className="font-medium">{item.price}</span>
              <span className="text-xs text-gray-500">{item.unit}</span>
              <span className={`text-xs font-medium ${item.isUp ? 'text-green-600' : 'text-red-600'}`}>
                {item.change}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-2 text-xs text-gray-500 flex items-center justify-between">
        Last updated: {new Date().toLocaleTimeString()}
        <span className="text-avn-purple-600 cursor-pointer hover:underline">View All</span>
      </div>
    </div>
  );
};

export default MarketPrices;